var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"id":"ICP"}},[_vm._v("广州奇点网络信息有限公司 "),_c('a',{attrs:{"href":"http://www.beian.miit.gov.cn/"}},[_vm._v("粤ICP备18089782号")])])}]

export { render, staticRenderFns }